import styled from "styled-components";

import { IThemeProps } from "@/styles/Theme";

type SectionProps = IThemeProps<{ $isCorrect?: boolean }>;
export const Section = styled.section<SectionProps>`
  display: block;
  margin: 0 auto;
  width: 100%;
  background-color: ${(props) =>
    props.$isCorrect ? props.theme.colors.success : props.theme.colors.error};
`;

export const Wrapper = styled.div<IThemeProps>`
  display: flex;
  height: 100%;
  min-height: ${(props) => props.theme.globals.minInteractionHeight};
  align-items: center;
  justify-content: center;
  flex-flow: column;
  padding: 20px;
`;

export const Title = styled.h2<IThemeProps>`
  display: block;
  margin: 0 auto;
  text-transform: uppercase;
  text-align: center;
  font-size: ${(props) => props.theme.typography.h700};
  font-weight: ${(props) => props.theme.typography.h300};
  color: ${(props) => props.theme.colors.white};
`;

export const ContentBox = styled.div<IThemeProps>`
  display: block;
  width: 100%;
  margin: 0 auto;
  padding: 20px;
  background-color: ${(props) => props.theme.colors.white};
  margin-top: ${(props) => props.theme.spacing.desktop.s400}px;
`;

export const Text = styled.p<IThemeProps>`
  display: block;
  margin: 0 auto;
  text-align: center;
  font-size: ${(props) => props.theme.typography.h600};
`;

export const ButtonWrap = styled.div<IThemeProps>`
  display: block;
  margin: 0 auto;
  margin-top: ${(props) => props.theme.spacing.desktop.s400}px;
`;

type ImageProps = IThemeProps<{ $showOnlyImage: boolean }>;
export const Image = styled.img<ImageProps>`
  position: relative;
  display: block;
  margin: 0 auto;
  overflow: hidden;
  background-color: ${(props) => props.theme.colors.white};
  border-color: ${(props) => props.theme.colors.white};
  border-style: solid;
  border-width: ${(props) => props.theme.borders.imageTile};
  box-shadow: ${(props) => props.theme.shadows.s200};
  width: 100%;
  height: auto;
  margin-top: ${(props) => (props.$showOnlyImage ? "0" : "18px")};
`;
